import axios from 'axios'
import Vue from 'vue'

Vue.prototype.$axios = axios

//API Basepath
//axios.defaults.baseURL   = 'http://localhost:3332/apiUbic'
//axios.defaults.baseURL   = 'https://rastreobdes.kuroda.com/apiUbic/'
axios.defaults.baseURL   = 'https://rastreob.kuroda.com/apiUbic/'